import style from "../../../../assets/scss/sub/consultantHistory.module.scss";
import {ConsultationItem, ConsultationModalType} from "../../../../types/consultation";
import LeftBtnIcon from "../../../../assets/images/mypage/left_button_icon.svg";
import RightBtnIcon from "../../../../assets/images/mypage/right_button_icon.svg";
import React from "react";
import {PageResponse} from "../../../../types/page";
import {useConsultationFunctions} from "./useConsultationFunctions";
import {useVoucherStore} from "../../../common/hooks/voucherStore";
import {useModal} from "../../../../hooks/hooks";
import {useConsultationPagination} from "./useConsultationPagination";
import {useConsultationModals} from "./ConsultationModalProvider";

interface Args{
    consultationHistory: PageResponse<ConsultationItem> | undefined;
    currentPage: number;
    handlePageChange: (_: number) => void
}
export function ConsultantHistoryColumns(
    {consultationHistory, currentPage, handlePageChange}:Args
) {
    const {getStatusMessage, getButtonContent} = useConsultationFunctions();
    const {consultingVoucherCount} = useVoucherStore();
    const {openConfirmModal, openAlertModal} = useModal();
    const {modalActions} = useConsultationModals();
    const {startPage, endPage} = useConsultationPagination({
        totalElements: consultationHistory?.totalElements ?? 0
    });

    const onClickCounselingButton = (item: ConsultationItem) => {
        if (process.env.REACT_APP_MODE === "운영") {
            openAlertModal({
                title:"상담 안내",
                desc: "상담 서비스는 현재 점검중입니다.\n2025년 상반기 서비스가 제공될 예정입니다.\n감사합니다."
            })
            return;
        }

        if (item.status === null && consultingVoucherCount === 0) { // 상담신청 + 상담 이용권이 없는 경우
            openConfirmModal(
                {
                    title: "상담 신청 안내",
                    desc: "상담이용권이 부족합니다.\n상담이용권 구매 페이지로 이동하시겠습니까?",
                },
                () => {
                    window.open(`/purchase-counselor`, "_blank", "noopener,noreferrer");
                }
            );
            return;
        }
        modalActions.toggleReserveModal(item)
    }

    return(
        <>
            <div>
                <div className={style.labelContainer}>
                    <div className={style.firstLabel}>검사종류</div>
                    <div className={style.secondLabel}>상담요청일</div>
                    <div className={style.thirdLabel}>상세보기</div>
                    <div className={style.fourthLabel}>상태</div>
                </div>
                {consultationHistory?.content && (
                    <div className={style.resultInfoContainer}>
                        {consultationHistory.content.map((item: ConsultationItem) => (
                            <div key={item.contentExecutedInfoIdx} className={style.resultInfoData}>
                                <div className={style.firstInfoData}>
                                    {item.unitVoucherType === "KPASS" ? "K-PASS" : "D-CAS"}
                                    <br/>
                                    {`${item.testRound}회차` || "-"}
                                </div>
                                <div className={style.secondInfoData}>
                                    {item.desiredDate ? item.desiredDate : "-"}
                                    {item.desiredTime ? (
                                        <>
                                            <br/>
                                            {item.desiredTime.slice(0, 5)}
                                        </>
                                    ) : (
                                        ""
                                    )}
                                </div>
                                <div className={style.thirdInfoData}>
                                    {getButtonContent(item, modalActions.toggleModal)}
                                </div>
                                <div
                                    className={`${style.fourthInfoData} ${item.status ? style[item.status.toLowerCase()] : ""}`}>
                                    {item?.status?.toLowerCase() === "allotted" ? (
                                        <>
                                            <span style={{cursor: "pointer"}}
                                                  onClick={() => modalActions.toggleModal({
                                                      consultation: item, modalType: ConsultationModalType.INFO
                                                  })}
                                                  className={`${style.allotted_consultant}`}>{item.consultantName}
                                            </span>
                                        </>
                                    ) : null}
                                    {!item.status ? (
                                        <button className={style.resultButton}
                                                onClick={() => {
                                                    onClickCounselingButton(item)
                                                }}>
                                            {getStatusMessage(item.status ?? undefined)}</button>
                                    ) : (
                                        <div style={{lineHeight:"140%"}}>{getStatusMessage(item.status)}</div>
                                    )}
                                </div>
                            </div>
                        ))}
                        {consultationHistory.content.length === 0 &&
                            <div className={style.noPaymentInfo}>검사 내역이 없습니다.</div>}
                    </div>
                )}

                <div className={style.paginationContainer}>
                    <div className={style.paginationDiv}>
                        <img
                            src={LeftBtnIcon}
                            className={style.leftButtonImg}
                            onClick={() => handlePageChange(currentPage - 1)}
                            alt="previous"
                        />
                        {Array.from({length: endPage - startPage}, (_, i) => startPage + i).map((page) => (
                            <button
                                key={page}
                                className={`${style.paginationBtn} ${page === currentPage ? style.active : ""}`}
                                onClick={() => handlePageChange(page)}
                            >
                                {page + 1}
                            </button>
                        ))}
                        <img
                            src={RightBtnIcon}
                            className={style.rightButtonImg}
                            onClick={() => handlePageChange(currentPage + 1)}
                            alt="next"
                        />
                    </div>
                </div>
            </div>
        </>
    )
}